{
  "footer": {
    "alreadyPartner": "¿Ya eres cliente?",
    "back": "Atrás",
    "letsgo": "¡Vamos!",
    "login": "Iniciar sesión ",
    "next": "Siguiente",
    "readMore": "Más información ",
    "signUp": "Registrarse"
  },
  "formErrors": {
    "address": "La dirección no se encuentra. Por favor, introduza una existente.",
    "businessName": "Este nombre no está disponible. Por favor, añade uno.",
    "email": "Este email ya existe",
    "verificationCode": "Código inválido",
    "turnstileToken": "Verificación fallida. Por favor, inténtalo de nuevo."
  },
  "global": {
    "title": "Únete a Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "El nombre del negocio es demasiado largo",
      "label": "Nombre del negocio",
      "required": "Obligatorio"
    },
    "businessSegment": {
      "aesthetics": "Estética",
      "barber": "Barbero",
      "beautician": "Esteticista",
      "hair-removal": "Depilación ",
      "hairdresser": "Peluquero",
      "massage": "Masaje",
      "nails": "Uñas",
      "primary": "Principal",
      "required": "Selecciona al menos uno",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Confirmo que tengo una habitación separada y dedicada para mi actividad",
      "home": "A domicilio <0>- tus clientes vienen a tu casa</0>",
      "mobile": "Móvil <0>- vas a casa de tus clientes</0>'",
      "mobileCheckbox": "Solo quiero usar Treatwell para la agenda y NO para la página de reservas.",
      "mobileMessage": "Desafortunadamente por limitaciones, nuestra página de reservas solo puede mostrar negocios con una dirección fija.",
      "required": "Selecciona uno",
      "shop": "Comercio <0>- tus clientas van a tu comercio</0>"
    },
    "city": {
      "invalid": "El nombre de la ciudad es demasiado largo",
      "label": "Ciudad",
      "required": "Obligatorio"
    },
    "country": {
      "label": "País",
      "required": "Obligatorio"
    },
    "email": {
      "invalid": "Inválido",
      "label": "Email",
      "required": "Obligatorio"
    },
    "firstName": {
      "invalid": "Por favor, recuerda no usar caracteres especiales",
      "label": "Nombre ",
      "required": "Obligatorio"
    },
    "lastName": {
      "invalid": "Por favor, recuerda no usar caracteres especiales",
      "label": "Apellido",
      "required": "Obligatorio"
    },
    "marketing": {
      "label": "Me gustaría recibir comunicaciones por correo electrónico con asesoramiento especializado para que mi negocio crezca"
    },
    "password": {
      "hint": "Mínimo 8 caracteres",
      "invalid": "La contraseña necesita al menos 8 caracteres",
      "label": "Contraseña",
      "required": "Obligatorio",
      "rules": {
        "error-messages": {
          "password-too-short": "Introduce al menos {{length}} caracteres.",
          "password-too-long": "¡Ups! Tu contraseña no puede tener más de {{length}} caracteres.",
          "password-needs-uppercase": "Tu contraseña debe contener una letra mayúscula.",
          "password-needs-lowercase": "Tu contraseña debe contener una letra minúscula."
        }
      }
    },
    "phoneNumber": {
      "invalid": "Número de teléfono inválido",
      "label": "Número de teléfono",
      "required": "Obligatorio"
    },
    "postalCode": {
      "invalid": "El código postal es demasiado largo",
      "label": "Código postal",
      "required": "Obligatorio"
    },
    "privacy": {
      "label": "Registrándote a la cuenta Freemium aceptas la <0>política de privacidad</0> y los <1>términos y condiciones</1> "
    },
    "searchBusiness": {
      "label": "Buscar negocio"
    },
    "street": {
      "invalid": "La dirección es demasiado larga",
      "label": "Dirección",
      "required": "Obligatorio"
    }
  },
  "salesMode": {
    "enterPassword": "Introduce la contraseña para el modo de ventas",
    "invalidPassword": "Contraseña incorrecta"
  },
  "stepContext": {
    "attractNewClients": "Atrae nuevos clientes",
    "buildRelationships": "Construye relaciones aún mejores con tus clientes",
    "growBusiness": "Haz crecer tu negocio de manera exponencial",
    "manageAppointments": "Gestiona todas tus citas sobre la marcha",
    "prompt": "Estás a 3 minutos de unirte a más de 75 000 salones que gestionan sus negocios, aumentan sus bases de clientes y sus ingresos.<br /><br />Con Treatwell podrás:",
    "prompt2": "... y mucho más",
    "title": "<0>Unirse a Treatwell</0> - la mayor plataforma de peluquerías y salones de belleza en Europa - nunca ha sido tan sencillo."
  },
  "stepCounter": {
    "step0": "Paso 1",
    "step1": "Paso 1",
    "step2": "Paso 2",
    "step3": "Paso 3",
    "step4": "Paso 4",
    "step5": "Enhorabuena"
  },
  "stepEmailVerification": {
    "rateLimited": "Has solicitado demasiados códigos. Usa el código que ya te hemos enviado por email o vuelve a intentarlo en unos minutos.",
    "resend": "Reenviar",
    "subTitle1": "Inserta el código y completa el registro",
    "subTitle2": "¿No lo has recibido?",
    "title": "<0>Ya casi está,</0> Te hemos enviado un email con un código de 6 dígitos"
  },
  "stepError": {
    "accountCreation": "Crea tu cuenta",
    "body": "Estamos teniendo problemas.\\nPor favor espera un minuto e inténtalo de nuevo",
    "bodyWithError": "Estamos teniendo problemas con {{reason}}.\\nPor favor espera un minuto e inténtalo de nuevo.",
    "button": "Reintentar",
    "title": "Ups. Algo salió mal."
  },
  "stepFinal": {
    "joke1Punchline": "¿Con o sin terapia?",
    "joke1Setup": "¿Cuánto cuesta una manicura?",
    "joke2Punchline": "¡Un cortado!",
    "joke2Setup": "¿Qué pide el barbero en el café?",
    "joke3Punchline": "",
    "joke3Setup": "",
    "joke4Punchline": "",
    "joke4Setup": "",
    "joke5Punchline": "",
    "joke5Setup": "",
    "subTitle": "Mientras esperas, estos son divertidísimos",
    "title": "Gracias, ¡vamos a montar tu negocio!<br />Danos <0>dos minutos...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Inscribirse",
    "alternativeMessage": "¿Estás usando la misma localización para registrar un nuevo salón en Treatwell?'",
    "button": "Registrarse",
    "message": "<0>¡Buenas noticias!</0> Su negocio ya está configurado con Treatwell."
  },
  "stepFourForm": {
    "prompt1": "Utilizaremos esta información para crear tu cuenta y ponernos en contacto contigo si es necesario.",
    "title": "Cuéntanos sobre ti"
  },
  "stepOneForm": {
    "prompt1": "Busca o introduzca el nombre de tu empresa",
    "title": "Cuéntanos sobre tu negocio"
  },
  "stepOneSearch": {
    "addManually": "¿No encuentras tu empresa? <0>Añádala manualmente</0>",
    "prompt1": "Escribe el nombre de tu empresa",
    "title": "Cuéntanos sobre tu negocio"
  },
  "stepThreeForm": {
    "title": "¿Qué tipo de negocio tienes?"
  },
  "stepTwoForm": {
    "prompt1": "Selecciona todo lo que corresponde, eligiendo primero el servicio principal",
    "title": "¿Qué servicios ofreces?"
  },
  "stepTurnstile": {
    "title": "¡Ya casi!",
    "description": "Por favor, completa la verificación de seguridad para iniciar sesión.",
    "loading": "Cargando verificación de seguridad…",
    "validationError": "Por favor, completa la verificación de seguridad"
  }
}
